export default __webpack_public_path__ + "static/media/icon-flash.b97738d8.svg";